export default __webpack_public_path__ + "static/media/whatsapp-logo-transparent-white.979702bf.png";